import React, {useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Select from 'react-select';

import "../Pagina.css";
import "../content-styles.css"

import Swal from 'sweetalert2'

import * as Hosts from '../../../Hosts';
import {
	reqGET,
	reqPUT,
	
    obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	//obter_distrito_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,

    passwordHash

} from '../../../Utils';

import { usarToken } from "../../../UseToken";

import Loader from '../../../loader'

import Navbar from "../Navbar/Navbar_00";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Footer from "../Footer/Footer_00";

import { language } from './Language';

export default function Perfil(props) {
    const [, set_dados] = useState(null);
    const is_logged_in = useRef(null);

    const user_info = useRef({});
      
    const [dados_config, set_dados_config] = useState({});
    const [dados_navbar, set_dados_navbar] = useState({});

    const [countries, set_countries] = useState([])
    const [districts, set_districts] = useState([])
    const [cities, set_cities] = useState([])
    const [villages, set_villages] = useState([])

    const [services, set_services] = useState([])    

	const [isloading, setLoading] = useState(true)
    const [isRedirect, setRedirect] = useState(false)

    const [lang, set_lang] = useState('pt');

    const [pwd, set_pwd] = useState('');
    const [new_pwd, set_new_pwd] = useState('');
    const [new_pwd_conf, set_new_pwd_conf] = useState('');

    const [agree, setAgree] = useState(false);
    
    useEffect(() => {

        (async () => {
            let temp_token_info = await usarToken().getToken()
            let token_info = JSON.parse(temp_token_info)

            obter_paises_em_pt(set_countries);

            if(token_info !== undefined && token_info !== null && token_info.user_info !== undefined) {
                set_dados(is_logged_in.current = true)
            }
            else {
                set_dados(is_logged_in.current = false)
            }

            if(is_logged_in.current) {
                if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                    set_dados_navbar(props.dados_navbar)
                }
            }

            if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                set_dados_config(props.dados_config)
            }

            let res_s = await reqGET(`${Hosts.SIMCore_API}/web/support/attributes/type/${Hosts.companycode}/service`)
            set_services(res_s.data)

            let getClientInfo = async (id_user) => {
                return await reqGET(`${Hosts.SIMCore_API}/entities/${Hosts.companycode}/${id_user}`)
                    .then(res => {

                        set_dados(user_info.current = res.data[0])

                        if(user_info.current.addresses[0].country === 'Portugal') {

                            obter_distritos_pt(set_districts)
            
                            obter_cidades_por_distrito(user_info.current.addresses[0].region, set_cities)
            
                            obter_freguesias_por_cidade(user_info.current.addresses[0].city, set_villages)

                        }
                        else if(user_info.current.addresses[0].country === '') {

                            set_dados(user_info.current.addresses[0].country = 'Portugal')

                            obter_distritos_pt(set_districts)
            
                            obter_cidades_por_distrito(user_info.current.addresses[0].region, set_cities)
            
                            obter_freguesias_por_cidade(user_info.current.addresses[0].city, set_villages)
                            
                        }

                        setAgree(res.data[0].info.marketing)

                        setLoading(false)
                    })
                    .catch(erro => console.log(erro))
            }
            if (props?.location?.state?.item !== undefined && props?.location?.state?.item !== '') {
                getClientInfo(props?.location?.state?.item)
            }
            else {
                setRedirect(true)
            }
        })()

        if(localStorage.getItem('lang') !== undefined  || localStorage.getItem('lang') !== null) {
            set_lang(localStorage.getItem('lang'))
        }

    }, [props]);

    const handleSubmit = async (e) => {
		e.preventDefault();

        console.log('user_info', user_info)

        if(user_info.current.info.name === '') {

            Swal.fire('', language[lang].name_error, 'info')
            return
        }
        if(user_info.current.info.email === '') {

            Swal.fire('', language[lang].email_error, 'info')
            return

        }

        if(new_pwd !== '') {
            let pwd_hash = passwordHash(pwd)
            if(pwd_hash === user_info.current.info.password) {

                if(new_pwd === new_pwd_conf) {
                    let npwd = passwordHash(new_pwd)
                    user_info.current.info.password = npwd

                }
                else {
                    Swal.fire('', language[lang].pwd_error, 'info')
                    return
                }

            }
            else {
                Swal.fire('', language[lang].old_pwd_error, 'info')
                return
            }
        }

        await reqPUT(`${Hosts.SIMCore_API}/entities`, user_info.current)

        Swal.fire('', language[lang].perfil_upadate_success, 'info')

	}

    const handle_change_info_documento_userinfo = (e) => {
        const { name, value } = e.target;

        if(name === 'email') {
            set_dados(user_info.current.info['username'] = value)
        }

        set_dados(user_info.current.info[name] = value)


    }

    const handle_change_info_documento_userinfo_addresses = (e) => {
        const { name, value } = e.target;

        set_dados(user_info.current.addresses[0][name] = value)

    }

    const handle_change_info_documento_userinfo_contacts = (e) => {
        const { name, value } = e.target;

        if (name === 'email')
            set_dados(user_info.current.info[name] = value)

        set_dados(user_info.current.contacts[0][name] = value)

    }

    const handle_change_info_documento_userinfo_contacts_responsables = (e) => {
        const { name, value } = e.target;

        set_dados(user_info.current.contacts[0]['person_responsables'][name] = value)

    }

    const checkboxHandler = () => {
      // if agree === true, it will be set to false
      // if agree === false, it will be set to true
      setAgree(!agree);
      // Don't miss the exclamation mark
    }

    const checkboxHandler_reload = (value) => {
        //console.log('AGREE', agree)
        if (value === true)
            return true
        else 
            return false
        // if agree === false, it will be set to true
        //setAgree(!agree);
        // Don't miss the exclamation mark
    } 

    const handle_change_pwd = (e) => {
        const { name, value } = e.target;

        if(name === 'pwd') {
            set_pwd(value)
        }
        else 
        if(name === 'new_pwd') {
            set_new_pwd(value)
        }
        else if(name === 'new_pwd_conf') {
            console.log('conf')
            set_new_pwd_conf(value)
        }

    }
    
    const change_country = e => {

        set_cities([])
        set_villages([])

        set_dados(user_info.current.addresses[0].city = '');
        set_dados(user_info.current.addresses[0].village = '');
        set_dados(user_info.current.addresses[0].region = '');

        if (e.value === "Portugal") {

            if (districts.length === 0) {
                //console.log('DISTRITOS VAZIOS')
                obter_distritos_pt(set_districts)
            }
        }

        set_dados(user_info.current.addresses[0].country = e.value);
    }

    const change_district = e => {

        set_cities([])
        set_villages([])

        obter_cidades_por_distrito(e.value, set_cities)

        set_dados(user_info.current.addresses[0].city = '');
        set_dados(user_info.current.addresses[0].village = '');
        set_dados(user_info.current.addresses[0].region = e.value);
    }

    const change_city = e => {

        set_villages([])

        obter_freguesias_por_cidade(e.value, set_villages)

        set_dados(user_info.current.addresses[0].village = '');
        set_dados(user_info.current.addresses[0].city = e.value);
    }

    const change_village = e => {
        set_dados(user_info.current.addresses[0].village = e.value);
    }

	const verify_services = (id_service) => {

		let result = false
		if(user_info.current.info.services !== undefined && user_info.current.info.services !== null) {
			user_info.current.info.services.forEach(el => {
				if(parseInt(el) === parseInt(id_service)) {
					result = true
				}
			})
		}

		return result

	}	
    
    const set_service = (id_service) => {

		if(user_info.current.info.services !== undefined && user_info.current.info.services !== null) {

			if(user_info.current.info.services.filter(el => parseInt(el) === parseInt(id_service)).length > 0) {
				set_dados(user_info.current.info.services = user_info.current.info.services.filter(el => parseInt(el) !== parseInt(id_service)))
			}
			else {
				set_dados(user_info.current.info.services.push(id_service))
			}

		}
		else {
			user_info.current.info.services = []
			set_dados(user_info.current.info.services.push(id_service))
		}

	}	
    
    const set_assistencia = () => {

		if(user_info.current.info.contrato_assistencia !== undefined && user_info.current.info.contrato_assistencia !== null) {
			set_dados(user_info.current.info.contrato_assistencia = !user_info.current.info.contrato_assistencia)
		}
		else {
			set_dados(user_info.current.info.contrato_assistencia = true)
		}

	}

	const custom_select_styles = {
		container: base => ({
			...base,
			borderRadius: "0px",
			width: '100%',
		}),
		control: base => ({
			...base,
			borderRadius: "0px",
			padding: "0px 10px",
			fontSize: '1rem',
		}),
		menu: base => ({
			...base,
			borderRadius: "0px",
		}),
	}

    return (
        isRedirect ? 
            <Redirect to={'/'} replace />
        :
        isloading ?
            <Loader />
        :
        <>
            <Navbar pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />

            <Breadcrumb /> 

            <div className="container-fluid mb-5">
                <div className="row">
                    <div className='col-12 bg-light py-5'>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-12 col-lg-10'>
                                    <h3 className="titulo-primario">
                                        <span>{language[lang].client_data}</span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <div className="container">
                                <div className='row'>
                                    <div className='col-12 col-lg-10 mx-auto mt-5'>
                                        <div className="row mb-3">
                                            <div className="col-12 col-md-8">
                                                <label className="form-label">{language[lang].dados_nome}</label>
                                                <input type="text" name="name" className="form-control rounded-0" placeholder="" value={user_info.current.info.name} onChange={handle_change_info_documento_userinfo} />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <label className="form-label">{language[lang].dados_email}</label>
                                                <input type="email" name="email" className="form-control rounded-0" placeholder="" value={(user_info.current.contacts[0].email !== '' ? user_info.current.contacts[0].email : user_info.current.info.email)} onChange={handle_change_info_documento_userinfo_contacts} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-12 col-md-4">
                                                <label className="form-label">{language[lang].dados_mobile_phone}</label>
                                                <input type="text" name="mobile_phone" className="form-control rounded-0" placeholder="" value={user_info.current.contacts[0].mobile_phone} onChange={handle_change_info_documento_userinfo_contacts} />
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <label className="form-label">{language[lang].dados_vat}</label>
                                                <input type="text" name="vat" className="form-control rounded-0" placeholder="" value={user_info.current.info.vat} onChange={handle_change_info_documento_userinfo} />
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <label className="form-label">{language[lang].birthday}</label>
                                                <input type="date" name="birthday" className="form-control rounded-0" placeholder="" value={user_info.current.info.birthday} onChange={handle_change_info_documento_userinfo} /> 
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-12 col-md-4">
                                                <label className="form-label">{language[lang].country}</label>
                                                <Select
                                                    className="div-select"
                                                    options={countries}
                                                    name="pais"
                                                    value={user_info.current.addresses[0].country === '' ? null : { label: user_info.current.addresses[0].country, value: user_info.current.addresses[0].country }}
                                                    placeholder={language[lang].country_placeholder}
                                                    onChange={change_country}
                                                    styles={custom_select_styles}
                                                />
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <label className="form-label">{language[lang].district}</label>
                                                <Select
                                                    className="div-select"
                                                    options={districts}
                                                    name="distrito"
                                                    value={user_info.current.addresses[0].region === '' ? null : { label: user_info.current.addresses[0].region, value: user_info.current.addresses[0].region }}
                                                    placeholder={language[lang].district_placeholder}
                                                    onChange={change_district}
                                                    styles={custom_select_styles}
                                                />
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <label className="form-label">{language[lang].city}</label>
                                                <Select
                                                    className="div-select"
                                                    options={cities}
                                                    name="concelho"
                                                    value={user_info.current.addresses[0].city === '' ? null : { label: user_info.current.addresses[0].city, value: user_info.current.addresses[0].city }}
                                                    placeholder={language[lang].city_placeholder}
                                                    onChange={change_city}
                                                    styles={custom_select_styles}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <label className="form-label">{language[lang].village}</label>
                                                <Select
                                                    className="div-select"
                                                    options={villages}
                                                    name="freguesia"
                                                    value={user_info.current.addresses[0].village === '' ? null : { label: user_info.current.addresses[0].village, value: user_info.current.addresses[0].village }}
                                                    placeholder={language[lang].village_placeholder}
                                                    onChange={change_village}
                                                    styles={custom_select_styles}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label">{language[lang].local}</label>
                                                <input type="text" name="localidade" value={user_info.current.addresses[0].localidade} className="form-control rounded-0" placeholder={language[lang].local_placeholder} onChange={handle_change_info_documento_userinfo_addresses} />

                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label">{language[lang].postal_code}</label>
                                                <input type="text" name="postal_code" value={user_info.current.addresses[0].postal_code} className="form-control rounded-0" placeholder={language[lang].postal_code_placeholder} onChange={handle_change_info_documento_userinfo_addresses} />
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-12 col-md-8">
                                                <label className="form-label">{language[lang].dados_morada}</label>
                                                <textarea type="text" rows="4" name="address_detail" className="form-control rounded-0" placeholder="" value={user_info.current.addresses[0].address_detail} onChange={handle_change_info_documento_userinfo_addresses} />
                                            </div>
                                        </div>

                                        <div className="row mb-3 d-none">
                                            <div className="col-12">
                                                <input type="checkbox" id="agree" onChange={checkboxHandler} defaultChecked={checkboxHandler_reload(agree)} readOnly={true} disabled={true} />
                                                <label className="ps-3" htmlFor="agree">{language[lang].agree_marketing}</label>

                                                <label className="pt-3 small" htmlFor="agree">{language[lang].terms_conditions_required}</label>
                                            </div>
                                        </div>

                                        <div className='row mt-3'>
                                            <div className="my-3">
                                                <h3 className="titulo-secundario">{language[lang].dados_responsavel}</h3>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-12 col-md-4">
                                                    <label className="form-label">{language[lang].dados_nome}</label>
                                                    <input type="text" name="name" className="form-control rounded-0" placeholder="" value={user_info.current.contacts[0]?.person_responsables !== undefined ? user_info.current.contacts[0]?.person_responsables[0]?.name : ''} onChange={handle_change_info_documento_userinfo_contacts_responsables} />
                                                </div>
                                                <div className="col-12 col-md-4">
                                                    <label className="form-label">{language[lang].dados_email}</label>
                                                    <input type="text" name="email" className="form-control rounded-0" placeholder="" value={user_info.current.contacts[0]?.person_responsables !== undefined ? user_info.current.contacts[0]?.person_responsables[0]?.email : ''} onChange={handle_change_info_documento_userinfo_contacts_responsables} />
                                                </div>
                                                <div className="col-12 col-md-4">
                                                    <label className="form-label">{language[lang].dados_mobile_phone}</label>
                                                    <input type="text" name="mobile_phone" className="form-control rounded-0" placeholder="" value={user_info.current.contacts[0]?.person_responsables !== undefined ? user_info.current.contacts[0]?.person_responsables[0]?.mobile_phone : ''} onChange={handle_change_info_documento_userinfo_contacts_responsables} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row mt-3'>
                                            <div className="my-3">
                                                <h3 className="titulo-secundario">{language[lang].dados_servicos}</h3>
                                            </div>
                                            <div className="row mb-3">
                                            
                                                <div className="col-12 col-md-6">

                                                    <div className="row">
                                                        {
                                                        services.map((v, k) => {
                                                            return (
                                                                <div key={k} className="col-12">
                                                                    <div className="form-check form-check-custom form-check-solid my-2">
                                                                        <input type="checkbox" id={'service-' + v.id} className="form-check-input rounded-0" defaultChecked={verify_services(v.id)} data-status="true" value={v.id} onClick={() => set_service(v.id)} />
                                                                        <label className="form-check-label" htmlFor={'service-' + v.id}>
                                                                            {v.info.name}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-6">

                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="form-check form-check-custom form-check-solid my-2">
                                                                <input type="checkbox" name='contrato_assistencia' id={'assistencia-0'} className="form-check-input rounded-0" defaultChecked={user_info.current.info.contrato_assistencia} value={user_info.current.info.contrato_assistencia} onClick={() => set_assistencia()} />
                                                                <label className="form-check-label" htmlFor={'assistencia-0'}>
                                                                    {language[lang].tem_contrato_assistencia}
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <div className="col-12 mt-3">
                                                            <label className="form-label">{language[lang].observation}</label>
                                                            <textarea name="observation" value={user_info.current.info.observation} className="form-control rounded-0" rows="4" onChange={handle_change_info_documento_userinfo} />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div className='row mt-3'>
                                            <div className="my-3">
                                                <h3 className="titulo-secundario">{language[lang].dados_acesso}</h3>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-12 col-md-4 d-none">
                                                    <label className="form-label">{language[lang].pwd}</label>
                                                    <input type="password" name="pwd" className="form-control rounded-0" placeholder="" value={pwd} onChange={handle_change_pwd} />
                                                </div>
                                                <div className="col-12 col-md-4">
                                                    <label className="form-label">{language[lang].pwd}</label>
                                                    <input type="text" name="username" className="form-control rounded-0" placeholder="" value={user_info.current.info.username} readOnly={true} disabled={true} />
                                                </div>
                                                <div className="col-12 col-md-4">
                                                    <label className="form-label">{language[lang].new_pwd}</label>
                                                    <input type="password" name="new_pwd" className="form-control rounded-0" placeholder="" value={new_pwd} onChange={handle_change_pwd} />
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <label className="form-label">{language[lang].new_pwd_conf}</label>
                                                    <input type="password" name="new_pwd_conf" className="form-control rounded-0" placeholder="" defaultValue={new_pwd_conf} onBlur={handle_change_pwd} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='text-end mt-5'>
                                            <Link className="btn btn-light rounded-0 px-4 me-2" to={{ pathname: '/list/clients' }} replace>
                                                {language[lang].prev}
                                            </Link>
                                            <button className="btn btn-secondary px-4" onClick={handleSubmit}> {language[lang].salvar} </button>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
        </>

    );
}

